export enum ButtonColor {
  Primary = "STYLE_1",
  Secondary = "STYLE_2",
  Tertiary = "STYLE_3",
  Quaternary = "STYLE_4",
}

export enum ButtonSize {
  Small = "SMALL",
  Medium = "MEDIUM",
  Large = "LARGE",
}

export enum ButtonVariant {
  Contained = "CONTAINED",
  Outlined = "OUTLINED",
  Text = "TEXT",
}

export enum ButtonCaptionPosition {
  Top = "TOP",
  Bottom = "BOTTOM",
}

export enum ButtonIcon {
  None = "NONE",
  Arrow = "ARROW",
}

export enum ButtonIconPosition {
  Left = "LEFT",
  Right = "RIGHT",
}
